/* unplugin-vue-components disabled */import script from "./MenuDish.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDish.vue?vue&type=script&setup=true&lang=js"

import "./MenuDish.vue?vue&type=style&index=0&id=125ca35b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125ca35b"]])

export default __exports__